// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"2a51cbe3","260":"4b160f12","334":"068909e3","355":"82fc1136","537":"465cd826","856":"0e1670ac","919":"6c1bf153"}[chunkId] + ".chunk.css";
};